import {
  DescriptionList,
  DescriptionListTerm,
  DescriptionListGroup,
  DescriptionListDescription,
} from '@patternfly/react-core'
import { Tr, Td } from '@patternfly/react-table'
import * as React from 'react'
import styled from 'styled-components'

import type { IDomainEvent } from '@app/domain/domain-events/domain-events.interface'

const Row = styled(Tr)`
  .label {
    width: fit-content;
  }
  .content {
    white-space: normal;
  }
`

interface Props {
  domainEvent: IDomainEvent
  expandedRows: Record<string, boolean>
  index: number
}

export const DefaultDomainEventRow = function ({
  domainEvent,
  expandedRows,
  index,
}: Props) {
  return (
    <Row key={index} isExpanded={expandedRows[domainEvent.id] === true}>
      <Td colSpan={5}>
        <DescriptionList columnModifier={{ xl: '3Col' }}>
          {domainEvent.userId ? (
            <DescriptionListGroup key={`description_group_${index}_user_id`}>
              <DescriptionListTerm className="label">
                User Id
              </DescriptionListTerm>
              <DescriptionListDescription className="content">
                {domainEvent.userId}
              </DescriptionListDescription>
            </DescriptionListGroup>
          ) : null}

          {Object.keys(domainEvent.data)
            .sort()
            .map((key) => (
              <DescriptionListGroup key={`description_group_${index}_${key}`}>
                <DescriptionListTerm className="label">
                  {key}
                </DescriptionListTerm>
                <DescriptionListDescription className="content">
                  {domainEvent.data[key]}
                </DescriptionListDescription>
              </DescriptionListGroup>
            ))}
        </DescriptionList>
      </Td>
    </Row>
  )
}
